import { ISalesInfoCardData } from "../interface/interface";

export const SALES_TRACKER_SUMMARY_TITLE: any = {
  callcount: 'Calls',
  emailcount: 'Emails',
  smscount: 'SMS',
  totalleads: 'Leads',
};
export const DEFAULT_CHART_OPTIONS = {
  series: [],
  chart: {
    width: 380,
    type: 'pie',
  },
  labels: [],
  colors: [
    '#506B85',
    '#1E2B38',
    '#62788D',
    '#8FA6C1',
    '#FF9922',
    '#2A3E50',
    '#168D8B',
    '#B6D0E8',
    '#2D3513',
    '#E63946',
    '#4CAF50',
    '#FFC107',
    '#9C27B0',
    '#FF5722',
    '#607D8B',
    '#8D6E63',
    '#00BCD4',
    '#03A9F4',
    '#F44336',
    '#9E9E9E',
  ],
  stroke: {
    width: 0,
  },
  legend: {
    position: 'bottom',
    horizontalAlign: 'center',
  },
  responsive: [
    {
      breakpoint: 480,
      options: {
        chart: {
          width: 300,
        },
      },
    },
  ],
};

export const CHART_TITLES: any = {
  sms: 'SMS',
  call: 'Calls',
  leads: 'Leads',
  email: 'Emails',
  totalConversions:"Total Conversions"
};

export const STATS_CARD_DATA: ISalesInfoCardData[] = [
    {
      icon: 'assets/images/email.svg',
      value: 0,
      label: 'Emails',
      // info: '',
      identifier: 'emailcount',
    },
    {
      icon: 'assets/images/message.svg',
      value: 0,
      label: 'SMS',
      // info: '10 Unread Messages',
      identifier: 'smscount',
    },
    {
      icon: 'assets/images/tel.svg',
      value: 0,
      label: 'Calls',
      // info: '10 Unanswered calls',
      identifier: 'callcount',
    },
  ];